import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/global.css";

const app = createApp(App);

// 滚动入场动画指令：v-reveal
app.directive("reveal", {
  mounted(el) {
    if (!("IntersectionObserver" in window)) {
      el.classList.add("revealed");
      return;
    }
    el.classList.add("reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("revealed");
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    io.observe(el);
  },
});

app.use(store).use(router).mount("#app");
